import { useCallback } from 'react';

// eslint-disable-next-line @change/sibling-module-imports -- direct import to avoid circular dependency
import { useModalConfirmationContext } from 'src/app/shared/components/payments/ModalConfirmationContext';

import { useSendVerificationEmail } from '../useSendVerificationEmail';

type Props = { showContinueAsGuest: boolean; userId: string; path: string };

export function useInformVerificationEmail(): (props: Props) => Promise<void> {
	const sendVerificationEmail = useSendVerificationEmail();

	const [, { displayModal }] = useModalConfirmationContext();

	return useCallback(
		async ({ showContinueAsGuest, userId, path }) => {
			// not great UX to be sending an email every time the page is loaded/refreshed
			void sendVerificationEmail(path, userId);
			await displayModal({ type: 'emailVerification', path, showContinueAsGuest, userId });
		},
		[sendVerificationEmail, displayModal],
	);
}
